import React from 'react';
import withSizes from 'react-sizes';

import UnlockButton from '../components/buttons/UnlockButton';
import LockIcon from './icons/LockIcon';

import '../css/unlock-pro-card.css';

function UnlockProCard(props) {
  return (
    <>
      <div className="my-5 text-center ">
        <div className="text-muted my-2">
          <span className="dashed">{props.text}</span></div>
        <div className="my-4 flex justify-center">
            {/*<LockIcon size={72} color="var(--text-muted)" />*/}
            <img className="svg-container" src="https://img.icons8.com/?size=100&id=EHyUO6ZGSRkX&format=png&color=000000"/>
        </div>
        <div>
            <UnlockButton text={'Unlock PRO Access'}></UnlockButton>
        </div>
      </div>
    </>
  );
};

UnlockProCard.defaultProps = {
  text: 'Unlock Pro Access'
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
  isDesktop: width >= 1024
})

export default withSizes(mapSizesToProps)(UnlockProCard);
